import { TRACK_ITEM_CLASS_NAME } from 'consts'
import Selecto from 'react-selecto'
import { useSelectoScroll, useOnSelect, useOnDragStart } from './hooks'
import { ISelectoProps } from './types'
import { useTimelineContext } from 'context/TimelineContext'

const ReactSelecto = (props: ISelectoProps) => {
  const {
    onAdd,
    onRemove,
    scrollableContainerRef,
    selectoRef,
    boundContainerRef
  } = props

  const { scrollOptions, onScrollEventHandler } = useSelectoScroll(
    scrollableContainerRef
  )
  const { setIsReactSelectoMultiDragging, isReactSelectoMultiDragging } =
    useTimelineContext()

  const onSelect = useOnSelect(onAdd, onRemove)
  const onDragStart = useOnDragStart()
  const onDragEnd = () => {
    setIsReactSelectoMultiDragging(false)
  }

  const onDrag = () => {
    if (!isReactSelectoMultiDragging) {
      setIsReactSelectoMultiDragging(true)
    }
  }

  return (
    <Selecto
      container={scrollableContainerRef}
      dragContainer={scrollableContainerRef}
      selectableTargets={[`.${TRACK_ITEM_CLASS_NAME}`]}
      boundContainer={boundContainerRef.current}
      onSelect={onSelect}
      hitRate={1}
      selectByClick={false}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDrag={onDrag}
      ref={selectoRef}
      {...(scrollOptions && { scrollOptions, onScroll: onScrollEventHandler })}
      className="selecto-container"
    ></Selecto>
  )
}

export default ReactSelecto
